module.exports = __webpack_public_path__ + "static/img/akum_800_55.8f3016c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_55.svg
// module id = vmFP
// module chunks = 1